<template>
  <section id="edit-branch-block" class="case-creation" v-loading="loading">
    <div
      class="case-creation__step case-creation__patient-information"
      v-loading="disableSubmitButton"
    >
      <div class="case-creation__card">
        <div class="case-creation__heading">
          <div class="title-with-icon">
            <span class="icon">
              <img
                src="@/assets/images/icons/icon-patient-info.svg"
                alt="icon"
                class="img-fluid"
              />
            </span>
            <h3 class="title">EDIT BRANCH</h3>
          </div>
        </div>
        <div class="case-creation__body" v-if="getSingleBranch">
          <div class="vue-form">
            <el-form :model="branchFormData">
              <el-row :gutter="20">
                <el-col :span="6">
                  <div class="case-creation__input">
                    <el-form-item class="mb-15">
                      <label for="text">
                        Location
                        <span class="star">*</span>
                      </label>

                      <el-input
                        placeholder="Location"
                        v-model="branchFormData.ordering_location"
                        
                      ></el-input>
                      <p
                        class="err"
                        v-if="
                          getBranchValidationErrors &&
                          getBranchValidationErrors.ordering_location
                        "
                      >
                        {{ getBranchValidationErrors.ordering_location }}
                      </p>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="5">
                  <div class="case-creation__input">
                    <el-form-item class="mb-15">
                      <label for="text">
                        Display Name
                        <span class="star">*</span>
                      </label>
                      <el-input
                        placeholder="Display Name"
                        v-model="branchFormData.display_name"
                        
                      ></el-input>
                      <p
                        class="err"
                        v-if="
                          getBranchValidationErrors &&
                          getBranchValidationErrors.display_name
                        "
                      >
                        {{ getBranchValidationErrors.display_name }}
                      </p>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="5">
                  <div class="case-creation__input">
                    <el-form-item class="mb-15">
                      <label for="text">
                        Location Code
                        <span class="star">*</span>
                      </label>
                      <el-input
                        placeholder="Enter Location Code"
                        v-model="branchFormData.location_code"
                        
                      ></el-input>
                      <p
                        class="err"
                        v-if="
                          getBranchValidationErrors &&
                          getBranchValidationErrors.location_code
                        "
                      >
                        {{ getBranchValidationErrors.location_code }}
                      </p>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="8">
                  <div class="case-creation__input">
                    <el-form-item class="mb-15">
                      <label for="text">
                        Address
                        <span class="star">*</span>
                      </label>
                      <el-input
                        placeholder="Address"
                        v-model="branchFormData.address"
                      ></el-input>
                      <p
                        class="err"
                        v-if="
                          getBranchValidationErrors &&
                          getBranchValidationErrors.address
                        "
                      >
                        {{ getBranchValidationErrors.address }}
                      </p>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="24">
                  <div class="case-creation__input">
                    <el-form-item class="mb-15">
                      <p
                        class="error"
                        v-if="
                          getBranchValidationErrors &&
                          getBranchValidationErrors.critical_error
                        "
                      >
                        {{ getBranchValidationErrors.critical_error }}
                      </p>
                    </el-form-item>
                  </div>
                </el-col>
              </el-row>
            </el-form>
          </div>
        </div>
      </div>
    </div>

    <div class="case-creation__actions">
      <ul class="list">
        <li>
          <el-button
            type="default"
            class="btn cancel-button"
            @click="cancelBranchDetails"
            >Cancel</el-button
          >
        </li>
        <li>
          <el-button
            type="success"
            class="btn save-button"
            @click="submitBranchDetails"
            :disabled="disableSubmitButton"
            :loading="disableSubmitButton"
            >Save</el-button
          >
        </li>
      </ul>
    </div>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import {
  successNotification,
  errorNotification,
} from "@/helpers/notifications";
export default {
  data() {
    return {
      loading: false,
      branchFormData: {
        ordering_location: "",
        display_name: "",
        location_code: "",
        address: "",
      },
      branchInfo: {},
      disableSubmitButton: false,
    };
  },
  computed: {
    ...mapGetters("branches", [
      "getBranchAddStatus",
      "getBranchValidationErrors",
      "getSingleBranch",
    ]),
    hospital_id() {
      if (this.$route.params.hospital_id) {
        return this.$route.params.hospital_id;
      }
      return null;
    },
    location_id() {
      if (this.$route.params.location_id) {
        return this.$route.params.location_id;
      }
      return null;
    },
  },
  async mounted() {
    await this.fetchSingleBranchInfo();
    this.$store.dispatch("branches/clearValidationErrors");
  },
  methods: {
    async fetchSingleBranchInfo() {
      let params = {
        location_id: this.location_id,
        hospital_id: this.hospital_id,
      };
      this.loading = true;
      await this.$store.dispatch("branches/fetchSingleBranch", params);
      this.loading = false;
      this.branchInfo = JSON.parse(JSON.stringify(this.getSingleBranch));
      this.branchFormData.ordering_location = this.branchInfo.ordering_location;
      this.branchFormData.display_name = this.branchInfo.display_name;
      this.branchFormData.location_code = this.branchInfo.location_code;
      this.branchFormData.address = this.branchInfo.address;
    },

    prepareBranchAddData() {
      this.branchFormData.hospital_id = this.hospital_id;
      this.branchFormData.location_id = this.location_id;
      return this.branchFormData;
    },
    async submitBranchDetails() {
      this.disableSubmitButton = true;

      const payload = this.prepareBranchAddData();

      await this.$store.dispatch("branches/editBranch", payload);

      if (this.getBranchAddStatus) {
        successNotification("Branch Updated successfully");

        this.cancelBranch();
      } else if (this.getBranchValidationErrors) {
        this.scrollToFirstError();
      } else if (!this.getBranchValidationErrors) {
        errorNotification("Error while adding new branch");
      }

      this.disableSubmitButton = false;
    },
    scrollToFirstError() {
      let el = this.$el.getElementsByClassName("error")[0];
      if (el) {
        el.scrollIntoView({ block: "center" });
      }
    },
    async cancelBranch() {
      this.$router.push({
        name: "Branches-List",
      });
    },
    cancelBranchDetails() {
      if (Object.keys(this.branchFormData).length === 0) {
        this.clearDataAndGoToBranches();
      } else {
        this.$confirm("Are you sure to cancel Update Branch?", "Warning", {
          confirmButtonText: "OK",
          cancelButtonText: "Cancel",
          type: "warning",
        }).then(() => {
          this.clearDataAndGoToBranches();
        });
      }
    },
    clearDataAndGoToBranches() {
      this.branchFormData = {};
      this.goToBranches();
    },
    goToBranches() {
      this.$router.push({ name: "Branches-List" });
    },
  },
};
</script>
